{
  "appointment": {
    "CONFIRMATION_NUMBER": "หมายเลขยืนยัน",
    "APPOINTMENT_ID": "ID การนัดหมาย",
    "APPOINTMENT_DATE": "วันที่นัดหมาย",
    "APPOINTMENT_TIME": "เวลานัดหมาย",
    "APPOINTMENT_TIMEZONE": "เขตเวลา",
    "APPOINTMENT_TYPE": "ประเภทการนัดหมาย",
    "SCHEDULED_DURATION": "ระยะเวลาที่กำหนด (นาที)",
    "STATUS": "สถานะ",
    "ARRIVAL_DATE": "วันที่มาถึง",
    "ARRIVAL_TIME": "เวลาที่มาถึง",
    "DEPARTURE_DATE": "วันที่ออกเดินทาง",
    "DEPARTURE_TIME": "เวลาที่ออกเดินทาง",
    "DWELL_TIME": "ระยะเวลาที่อยู่ในสถานที่ (นาที)",
    "ON_TIME": "ความตรงเวลา (นาที)",
    "IN_PROGRESS_DATE": "วันที่เริ่มดำเนินการ",
    "IN_PROGRESS_TIME": "เวลาที่เริ่มดำเนินการ",
    "WAIT_TIME": "เวลารอ (นาที)",
    "PROCESSING_TIME": "เวลาดำเนินการ (นาที)",
    "WAREHOUSE": "คลังสินค้า",
    "DOCK": "ท่าเทียบรถ",
    "LOAD_TYPE": "ประเภทสินค้า",
    "LOAD_TYPE_DIRECTION": "ทิศทาง",
    "RESCHEDULE_COUNT": "จำนวนครั้งที่เลื่อนนัด",
    "CREATED_BY": "สร้างโดย",
    "CREATOR_TYPE": "ประเภทผู้สร้าง",
    "CREATION_DATE": "วันที่สร้าง",
    "LAST_UPDATED_BY": "อัปเดตล่าสุดโดย",
    "LAST_UPDATE_DATE": "วันที่อัปเดตล่าสุด",
    "LAST_UPDATE_TIME": "เวลาที่อัปเดตล่าสุด",
    "CARRIER_COMPANY": "บริษัทขนส่ง",
    "CONTACT_NAME": "ชื่อผู้ติดต่อ",
    "CONTACT_EMAIL": "อีเมลผู้ติดต่อ",
    "CONTACT_PHONE": "โทรศัพท์ผู้ติดต่อ",
    "NOTES": "หมายเหตุ",
    "TAGS": "แท็ก",
    "CUSTOM_FIELDS": "ช่องข้อมูลที่กำหนดเอง",
    "EXTERNAL_VALIDATION_STATUS": "สถานะการตรวจสอบภายนอก",
    "EXTERNAL_VALIDATION_ERROR_MESSAGE": "ข้อความแสดงข้อผิดพลาดการตรวจสอบภายนอก",
    "CheckOut": "เช็กเอาต์",
    "CheckInAdditionalAssetDetails": "รายละเอียดอุปกรณ์เพิ่มเติมเมื่อเช็กอิน",
    "InboundClaim": "การเคลมขาเข้า",
    "OutboundClaim": "การเคลมขาออก",
    "BookLoadType": "ประเภทสินค้าที่จอง",
    "AssetContainerDetails": "รายละเอียดตู้คอนเทนเนอร์",
    "AppointmentCompleted": "การนัดหมายเสร็จสิ้น"
  },
  "assetVisit": {
    "id": "ID การเข้าพื้นที่",
    "appointmentId": "ID การนัดหมาย",
    "checkInDate": "วันที่/เวลาเช็กอิน",
    "checkOutDate": "วันที่/เวลาเช็กเอาต์",
    "carrier": "ผู้ขนส่ง",
    "warehouseName": "คลังสินค้า",
    "currentStatus": "สถานะ",
    "licensePlate": "ป้ายทะเบียน",
    "visitType": "ประเภทการเข้าพื้นที่",
    "dotNumber": "หมายเลข DOT",
    "phone": "โทรศัพท์",
    "isPlanned": "มีการวางแผน",
    "driverNotes": "หมายเหตุของคนขับ",
    "checkInAcknowledged": "รับทราบการเช็กอินแล้ว",
    "firstName": "ชื่อจากการยืนยันตัวตน",
    "lastName": "นามสกุลจากการยืนยันตัวตน",
    "birthdate": "วันเกิดจากการยืนยันตัวตน",
    "idValidationEmail": "อีเมลจากการยืนยันตัวตน",
    "idValidationPhone": "โทรศัพท์จากการยืนยันตัวตน"
  }
}
